function OkIcon(props)
{
    return(
        <svg className={props.class?props.class:''} width="1.5rem" height="1.5rem" fill="rgba(60, 255, 0, 1)" viewBox="0 0 24 24">
  <polygon points="9.993 19.421 3.286 12.58 4.714 11.179 10.007 16.579 19.293 7.293 20.707 8.707 9.993 19.421"/>
</svg>
    )
}

export default OkIcon